import { render, staticRenderFns } from "./CompanyWalletDetails.vue?vue&type=template&id=e0fa47a6"
import script from "./CompanyWalletDetails.vue?vue&type=script&lang=js"
export * from "./CompanyWalletDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports